// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"20":"f84c13ab","509":"c573dee5"}[chunkId] + ".css";
};